module.exports = __webpack_public_path__ + "static/media/end.68686070.mp3";